import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { useNewbuildingPurchaseGiftPromo } from './NewbuildingPurchaseGiftPromoContext';
import { trackEntryPointShow } from './tracking';
import { Layout } from '../../components/Layout';
import { NewbuildingPurchaseGiftBanner } from '../../components/NewbuildingPurchaseGiftBanner';
import {
  NEWBUILDING_PURCHASE_GIFT_BANNER_LINK_TEXT,
  NEWBUILDING_PURCHASE_GIFT_BANNER_SUBTITLE,
  NEWBUILDING_PURCHASE_GIFT_BANNER_TITLE,
} from '../../constants/newbuildingPurchaseGiftPromo';

export const NewbuildingPurchaseGiftBannerContainer: React.FC = () => {
  const { isAvailable, openModal } = useNewbuildingPurchaseGiftPromo();

  const handleShow = React.useCallback(() => trackEntryPointShow('banner'), []);
  const handleClick = React.useCallback(() => openModal('banner'), [openModal]);

  if (!isAvailable) {
    return null;
  }

  return (
    <Layout>
      <ActionAfterViewObserver callback={handleShow} triggerOnce>
        <NewbuildingPurchaseGiftBanner
          title={NEWBUILDING_PURCHASE_GIFT_BANNER_TITLE}
          subtitle={NEWBUILDING_PURCHASE_GIFT_BANNER_SUBTITLE}
          linkText={NEWBUILDING_PURCHASE_GIFT_BANNER_LINK_TEXT}
          onClick={handleClick}
        />
      </ActionAfterViewObserver>
    </Layout>
  );
};
